const DefaultFormStyle = () => {
  return { width: '100%', margin: '0 10px', marginBottom: 1 };
};

export default DefaultFormStyle;
